// Right sidebar Backlinks / Outgoing panes.
import { clear, h } from './dom.js';
import { toast } from './modals.js';
import type { LinkRef } from './types.js';
import type { App } from './app.js';

function linkRows(app: App, refs: LinkRef[], emptyText: string): HTMLElement[] {
  if (refs.length === 0) return [h('p', { class: 'empty-note', text: emptyText })];
  return refs.map((ref) => {
    const row = h('button', {
      class: `link-row${ref.exists ? '' : ' unresolved'}`,
      type: 'button',
      title: ref.path,
    }, [
      h('span', { class: 'link-title', text: ref.title || ref.path }),
      h('span', { class: 'link-path', text: ref.path }),
    ]);
    row.addEventListener('click', () => {
      if (ref.exists) {
        void app.open(ref.path);
        return;
      }
      toast(`“${ref.path}” does not exist yet`, {
        actionLabel: 'Create note',
        onAction: () => void app.createNoteWithName(ref.path),
      });
    });
    return row;
  });
}

/** One link list (backlinks or outgoing) bound to the open note. */
export class LinkPane {
  readonly el: HTMLElement;
  private readonly list: HTMLElement;
  private readonly app: App;
  private readonly emptyText: string;

  constructor(app: App, emptyText: string) {
    this.app = app;
    this.emptyText = emptyText;
    this.list = h('div', { class: 'link-list' });
    this.el = h('div', { class: 'link-pane' }, [this.list]);
  }

  setRefs(refs: LinkRef[]): void {
    clear(this.list);
    for (const row of linkRows(this.app, refs, this.emptyText)) this.list.append(row);
  }
}
